<template>
  <div
    class="filter-aside"
  >
    <template v-if="filters && filters.length">
      <ul
        ref="menubar"
        class="filter-aside--inner"
      >
        <template v-for="(filter, index) in filters">
          <li
            class="filter-aside-item"
            v-if="filter.filter_values.length"
            :key="index"
          >
            <div class="el-text el-text--ellipsis filter-label">{{ filter.item_label }}</div>
            <ul :class="`filters-list ${filter.filter_var}`">
              <li v-for="values in filter.filter_values" :key="values.value">
                <el-checkbox
                  :checked="selectedFilters[filter.filter_var] && selectedFilters[filter.filter_var].findIndex(item => item === values.value) !== -1"
                  @change="filterChange(values.value, index)">
                  {{ values.label }}
                </el-checkbox>
              </li>
            </ul>
          </li>
        </template>
      </ul>
    </template>
    <el-spinner color="white" v-else/>
  </div>
</template>

<script>
export default {
  name: 'RaceFilterSidebar',
  props: {
    filters: {
      type: Array,
      required: true
    },
    selectedFilters: {
      type: Object,
      required: true
    }
  },
  methods: {
    filterChange(value, filterTitle) {
      this.$emit('changeFiltersHandler', value, filterTitle, 'left_filters')
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-aside {
  width: 200px;
  .filter-aside-header {
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
  }
  ul {
    padding-left: 20px;
    margin-top: 0
  }
  li {
    list-style-type: none;
  }
  .filter-label {
    font-weight: bold;
  }
  .filters-title {
    font-size: 20px;
  }
  .filters-list {
    padding-left: 10px;
    &.car_number {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 33%;
      }
    }
  }
}
</style>
